// extracted by mini-css-extract-plugin
module.exports = {"card":"card--3Zu0c"};